var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-card',[_c('md-card-content',[_c('md-tabs',{staticClass:"md-secondary",attrs:{"md-alignment":"centered"}},[_c('md-tab',{attrs:{"id":"tab-auction-services","md-label":"Auction Rules"}},[_c('AuctionList')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }